__turbopack_context__.v({
  "className": "fonts_7f2a12a2-module__3MHnqa__className",
});
